import webApi from "./api";
import store from "@/store";
import topPageService from "./top-page";

export class VehicleInfoService {
  getInfoRedbook(params) {
    return webApi.get("/car-detail/redbook-october", {
      params,
    });
  }
  getInfoAutograb(params) {
    return webApi.get("/car-detail/autograb", {
      params,
    });
  }
  async getInfo(params) {
    let vehicleDataSource = store.getters.systemConfigurations.vehicleDataSource;

    if (!vehicleDataSource) {
      try {
        const systemConfigResult = await topPageService.getSystemConfig();
        vehicleDataSource =
          systemConfigResult.status === 200 &&
          systemConfigResult.data.vehicleDataSource
            ? systemConfigResult.data.vehicleDataSource
            : null;
      } catch (error) {
        console.error('Failed to get system configurations:', error);
        return this.getInfoRedbook(params);
      }
    }

    // Check if activeSource is RB, then use searchRedbookRego
    if (vehicleDataSource?.activeSource === "RB") {
      return this.getInfoRedbook(params);
    }
    // Check if activeSource is AG, then use searchAutograbRego
    else if (vehicleDataSource?.activeSource === "AG") {
      return this.getInfoAutograb(params);
    }
    // Default fallback to redbook API
    else {
      return this.getInfoRedbook(params);
    }
  }
}

const vehicleInfoService = new VehicleInfoService();

export default vehicleInfoService;
